{
  "name": "Test",
  "key": "T",
  "production": false,
  "apiBaseUrl": "https://testapi-moncq.soluzione1.it/moncqcheck-rest/rest"
}
